import IntroBanner from "./IntroBanner";

export { IntroBanner };

export default IntroBanner;
